<template>
    <div class="modal-body">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
            <label class="form-label">Title</label>
            <div class="input-group input-group-merge w-100">
                <input
                    name="name"
                    type="text"
                    class="form-control"
                    placeholder="Enter Title"
                    v-model="formData.title"
                />
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
            <label class="form-label">Date & Time</label>
            <div class="input-group input-group-merge w-100">
                <input
                    name="datetime"
                    type="datetime-local"
                    class="form-control"
                    v-model="formData.start_time"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Assign To</label>
                <AsyncSelect
                      placeholder="Assign To"
                      :disabled="isCreator"
                      v-model="formData.assign_to"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'employee', status: 'active'}"
                      label="name"
                />
            </div>
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Report To</label>
                  <AsyncSelect
                      placeholder="Report To"
                      :disabled="isCreator"
                      v-model="formData.report_to"
                      :api-service="fetchContactProfiles"
                      :additional-query="{roles: 'employee', status: 'active'}"
                      label="name"
                  />
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
            <label for="colFormLabel" class="col-form-label">Participants </label>
                <AsyncSelect
                    multiple
                    :disabled="isParticipant"
                    placeholder="Select participants"
                    v-model="formData.participants"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'employee', status: 'active'}"
                    label="name"
                />
        </div>

        <div class="row justify-content-end">
            <div class="col-auto btn-margin text-right">
              <button type="button" class="more-options-btn" @click="isMoreSelected = !isMoreSelected">
                <i :class="isMoreSelected ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                {{ isMoreSelected ? 'Less Options' : 'More Options' }}
              </button>
            </div>
        </div>

        <div v-if="isMoreSelected">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Organization Activity</label>
                      <AsyncSelect
                          :disabled="isParticipant"
                          placeholder="Select Activity"
                          v-model="formData.activity_setup_id"
                          :api-service="fetchActivitySetupEndpoint"
                          label="name"
                          :reduce="item => item.id"
                          :additional-option="(editData && editData.activity_setup_id)
                            ? [{
                                id: editData.activity_setup_id,
                                name: editData.activity_setup_name
                              }]
                            : []"
                      />
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Deal</label>
                        <AsyncSelect
                            placeholder="Select Deal"
                            v-model="formData.deal"
                            :api-service="fetchDealNameList"
                            label="name"
                            :disabled="isFromDeal"
                        />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Client</label>
                      <AsyncSelect
                          placeholder="Client"
                          v-model="formData.client"
                          :disabled="isParticipant || isFromDeal"
                          :api-service="fetchContactProfiles"
                          :additional-query="{roles: 'customer,lead'}"
                          @option:selected="onChangeSelectedClient"
                          label="name"
                      />
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Tag</label>
                    <v-select
                        multiple
                        placeholder="Select Tag"
                        :disabled="isParticipant"
                        v-model="formData.tag"
                        :options="tagList"
                        label="name"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Project</label>
                      <AsyncSelect
                          placeholder="Select Project"
                          :disabled="isParticipant"
                          v-model="formData.project"
                          :api-service="fetchProjects"
                          label="name"
                          @option:selected="onChangeSelectedProject"
                          ref="projectDropdown"
                          :additional-query="{ with_donors: 1, party_id: formData.client && formData.client.id }"
                      />
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label class="form-label">Project Activity</label>
                    <AsyncSelect
                        placeholder="Select Project Activity"
                        v-model="formData.project_activity"
                        :disabled="isParticipant"
                        :api-service="fetchProjectActivity"
                        ref="projectActivityDropdown"
                        label="name"
                        :additional-query="{ project_id: formData.project && formData.project.id }"
                    />
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Priority</label>
                <v-select
                    placeholder="Select Priority"
                    v-model="formData.priority"
                    :disabled="isParticipant"
                    :options="priorityList"
                    label="name"
                />
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Description</label>
                <div class="input-group input-group-merge w-100">
                    <textarea
                        :disabled="isParticipant"
                        v-model="formData.description"
                        name="reference" rows="2"
                        placeholder="Enter Description"
                        class="form-control add-credit-card-mask"
                    >
                    </textarea>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
                <label class="form-label">Attachment</label>
                <BlobFileViewer :attachments="formData.attachments" />
                <FileUpload
                    :is-drag-active="true"
                    button-text="Upload Documents"
                    v-model="formData.attachments"
                >
                </FileUpload>
            </div>
        </div>

        <div v-if="isWorkStatusForm || showMinuteTab">
          <div v-if="! isNested && showMinuteTab" class="inner-tabs" role="tablist">
              <button
                  type="button"
                  role="tab"
                  :aria-selected="innerTab === 'work_status'"
                  :class="['inner-tab', { 'inner-tab--active': innerTab === 'work_status' }]"
                  @click="innerTab = 'work_status'"
              >
                  Current Work Status
              </button>
              <button
                  type="button"
                  role="tab"
                  :aria-selected="innerTab === 'minute'"
                  :class="['inner-tab', { 'inner-tab--active': innerTab === 'minute' }]"
                  @click="innerTab = 'minute'"
              >
                  Meeting Minute
              </button>
          </div>

          <div v-if="innerTab === 'minute' && ! isNested && showMinuteTab">
              <p v-if="! formData.id" class="text-center my-3">Please save this task first to add meeting minutes.</p>
              <MeetingMinute
                  v-if="formData.id"
                  :parentActivityLogId="formData.id"
                  :parentType="formData.type"
                  :reloadTrigger="reloadMinuteTrigger"
                  @openScheduler="onOpenScheduler"
                  ref="minuteRef"
              />
          </div>

          <div v-if="isWorkStatusForm && (innerTab === 'work_status' || isNested || ! showMinuteTab)">
          <div class="d-flex align-items-center gap-1 mb-1">
            <h4 class="fw-bolder mb-0">My Work Status</h4>
            <span
                v-if="workStatusFormData.status"
                class="work-status-pill"
                :style="workStatusPillStyle"
            >
              {{ workStatusFormData.status }}
            </span>
          </div>

          <div v-if="isWorkStatusReturned" class="alert alert-warning py-1 px-2">
            <strong>Returned</strong>
            <span class="work-status-meta">
              by {{ workStatusComment.updated_by_name }} · {{ workStatusComment.logged_at }}
            </span>
            <div>{{ workStatusComment.comment }}</div>
          </div>

          <div v-if="isWorkStatusRejected" class="alert alert-danger py-1 px-2">
            <strong>Rejected</strong>
            <span class="work-status-meta">
              by {{ workStatusComment.updated_by_name }} · {{ workStatusComment.logged_at }}
            </span>
            <div>{{ workStatusComment.comment }}</div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-8 mb-1">
              <label class="form-label">Description</label>
              <div class="input-group input-group-merge w-100">
                    <textarea
                        v-model="workStatusFormData.description"
                        name="reference" rows="2"
                        placeholder="Enter Description"
                        class="form-control add-credit-card-mask"
                        :disabled="isWorkStatusLocked"
                    >
                    </textarea>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Input Hours</label>
              <input
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Hours"
                  v-model="workStatusFormData.hours"
                  :disabled="isWorkStatusLocked"
              />
            </div>

             <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Location</label>
              <AsyncSelect
                  placeholder="Select Location"
                  v-model="workStatusFormData.area_id"
                  :api-service="fetchAreaList"
                  label="label"
                  :disabled="isWorkStatusLocked"
                  @option:selected="handleLocationChange"
              />
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Conveyance Bill</label>
              <input
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Conveyance Bill"
                  v-model="workStatusFormData.conveyance"
                  :disabled="isWorkStatusLocked"
              />
            </div>

            <div class="col-12 col-sm-12 col-md-4 mb-1">
              <label class="form-label">Date</label>
              <input
                  name="name"
                  type="date"
                  class="form-control"
                  placeholder="Enter Date"
                  v-model="workStatusFormData.date"
                  :disabled="isWorkStatusLocked"
              />
            </div>
          </div>
          </div>
      </div>

    </div>
</template>

<script setup>
import {ref, reactive, computed, onMounted, watch} from 'vue';
import { getCurrentDateTime, getTaskStatusColor } from '@/services/utils/global.js';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'
import handleDropDowns from '@/services/modules/dropdowns'
import {useRoute} from "vue-router";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import handleProjects from "@/services/modules/procurement/project";
import handleCrm from '@/services/modules/crm/crm'
import handleAdmin from '@/services/modules/admin/admin';
import useDate from '@/services/utils/day';
import MeetingMinute from './MeetingMinute.vue';

const {fetchContactProfiles} = handleContact()
const { fetchActivitySetupEndpoint } = handleDropDowns();
const { fetchProjectActivity, fetchProjects} = handleProjects();
const { fetchAreaList, fetchSingleArea } = handleCrm();
const { fetchDealNameList } = handleAdmin();
const { formatToDate } = useDate();

const projectActivityDropdown = ref(null)
const projectDropdown = ref(null)
const minuteRef = ref(null)
const props = defineProps({
    startDate: String,
    tagList: Array,
    editData: {
      type:Object,
      default: {}
    },
    taskStatus: {
      type:Object,
      default: {}
    },
    workStatus: {
      type:Object,
      default: {}
    },
    markAsDoneShow:{
      type:Boolean,
      default: false
    },
    isCompleted:{
      type:Boolean,
      default: false
    },
    dealId: {
      type: Number,
      default: null
    },
    dealCustomer: {
        type: Object,
        required: true
    },
    dealData: {
      type: Object,
      default: {}
    },
    isFromDeal: {
      type: Boolean,
      default: false
    },
    priorityList: Array,
    isNested: {
      type: Boolean,
      default: false
    },
    reloadMinuteTrigger: {
      type: Number,
      default: 0
    }
});

const emit = defineEmits(['openScheduler', 'tabChange']);
const innerTab = ref('work_status');

const showMinuteTab = computed(() => {
  return !! (props.taskStatus && props.taskStatus.assigned_to);
});

const onOpenScheduler = (payload) => {
  emit('openScheduler', payload);
}

watch(innerTab, (value) => {
  emit('tabChange', value);
}, { immediate: true });

const reloadMinutes = () => {
  if (! minuteRef.value) {
    return;
  }
  minuteRef.value.reloadMinutes();
}

const route = useRoute();

const markDoneFormData = reactive({
  id:null,
})

const workStatusFormData = reactive({
  id:null,
  area_id: null,
  conveyance: null,
  hours: null,
  date: null,
  description: null,
  status: null
})

const workStatusComment = ref(null);

const isWorkStatusLocked = computed(() => {
  return ['approved', 'rejected'].includes(workStatusFormData.status)
});

const isWorkStatusReturned = computed(() => {
  if (! workStatusComment.value) return false
  return workStatusFormData.status === 'returned'
});

const isWorkStatusRejected = computed(() => {
  if (! workStatusComment.value) return false
  return workStatusFormData.status === 'rejected'
});

const workStatusPillStyle = computed(() => {
  const color = getTaskStatusColor(workStatusFormData.status)
  return {
    backgroundColor: color.bg,
    color: color.text,
    border: `1px solid ${color.border}`
  }
});

const formData = reactive({
    id: null,
    type: 'task',
    assign_to: null,
    report_to: null,
    activity_setup_id: null,
    client: '',
    project: '',
    project_activity: '',
    tag: [],
    priority: null,
    start_time: getCurrentDateTime(props.startDate),
    title: '',
    deal: '',
    description: '',
    attachments: [],
    participants: [],
    route_name:'task-calendar',
    parent_activity_log_id: null
});

const resetForm = () => {
  formData.id = null;
  formData.title = '';
  formData.start_time = null
  formData.description = '';
  formData.assign_to = null;
  formData.report_to = null;
  formData.activity_setup_id = null;
  formData.client = '';
  formData.project = '';
  formData.deal = '';
  formData.project_activity = '';
  formData.priority = null;
  formData.participants = [];
  formData.tag = [];
  formData.attachments = [];
  formData.parent_activity_log_id = null;
  workStatusFormData.area_id = null;
  workStatusFormData.hours = null;
  workStatusFormData.description = null;
  workStatusFormData.date = null;
  workStatusFormData.conveyance = null;
};

const isMoreSelected = ref(false);
const isCreator = ref(false);
const isParticipant = ref(false);
const isMarkDoneForm = ref(false);
const isWorkStatusForm = ref(false);

function getFormData() {
  return {...formData};
}

function getMarkDoneFormData() {
  return {...markDoneFormData};
}

function getWorkStatusFormData() {
  return {...workStatusFormData};
}

const onChangeSelectedProject = () => {
  formData.project_activity = null;
  projectActivityDropdown.value.clear();
}

const onChangeSelectedClient = () => {
  formData.project_activity = null;
  formData.project = null;
  projectDropdown.value.clear();
}

const handleLocationChange = async (newArea) => {
  if (!newArea || !newArea.id) {
    workStatusFormData.conveyance = 0
    return
  }

  const query = `?company_id=${route.params.companyId}`
  try {
    const area = await fetchSingleArea(newArea.id, query)
    if (area) {
      workStatusFormData.conveyance = area.data.amount
    }
  } catch (error) {
    workStatusFormData.conveyance = 0
  }
}

onMounted(() => {
  if (props.editData && Object.keys(props.editData).length) {
    const valuesMap = {};

    props.editData.values &&  props.editData.values.forEach((val) => {
      const obj = val.field_value
          ? {
            ...val.field_value,
            id: val.field_value_id,
            name: val.field_value.full_name || val.field_value.name || val.field_value.deal_number ||  '',
          }
          : null;

      if (['participant_id', 'tag_id'].includes(val.field_key)) {
        if (!valuesMap[val.field_key]) valuesMap[val.field_key] = [];
        if (obj) valuesMap[val.field_key].push(obj);
      }
      if (!['participant_id', 'tag_id'].includes(val.field_key)) {
        valuesMap[val.field_key] = obj;
      }
    });
    
    markDoneFormData.id = props.editData.id;

    formData.id = props.editData.id
    formData.title = props.editData.short_description || '';
    formData.start_time = props.editData.start_time || getCurrentDateTime(props.startDate);
    formData.description = props.editData.full_description || '';
    if (props.editData.type) {
      formData.type = props.editData.type;
    }
    formData.activity_setup_id = props.editData.activity_setup_id;
    formData.assign_to = valuesMap['assigned_to'] || null;
    formData.report_to = valuesMap['report_to'] || null;
    formData.client = valuesMap['client_id'] || '';
    formData.project = valuesMap['project_id'] || '';
    formData.project_activity = valuesMap['project_activity_id'] || '';
    formData.priority = valuesMap['priority_id'] || null;
    formData.participants = valuesMap['participant_id'] || [];
    formData.tag = valuesMap['tag_id'] || [];
    formData.deal = valuesMap['deal_id'] || '';
    formData.attachments = props.editData.attachments || [];
  }

  if (props.editData && props.editData.parent_activity_log_id) {
    formData.parent_activity_log_id = props.editData.parent_activity_log_id;
  }

  if (props.workStatus && Object.keys(props.workStatus).length > 0) {
    isWorkStatusForm.value = true;
    workStatusFormData.id = props.workStatus.id;
    workStatusFormData.area_id = {
      id: props.workStatus.area_id,
      label: props.workStatus.area_label
    };
    workStatusFormData.hours = props.workStatus.hours;
    workStatusFormData.date = formData.start_time ? formatToDate(formData.start_time) 
                                                  : new Date().toISOString().split('T')[0];
    workStatusFormData.description = props.workStatus.description;
    workStatusFormData.conveyance = props.workStatus.conveyance;
    workStatusFormData.status = props.workStatus.status;
    workStatusComment.value = props.workStatus.last_comment;
  }

  const ts = props.taskStatus || {};

  if (ts && !ts.is_created && Object.keys(ts).length){
    isCreator.value = true;
  }
  if (
      Object.keys(ts).length &&
      ts.participant &&
      !ts.is_created &&
      !ts.report_to &&
      !ts.assigned_to
  ) {
    isParticipant.value = true;
  }
  if (props.isCompleted && !ts.report_to){
    isMarkDoneForm.value = true;
  }
  if(props.dealId){
    formData.deal = {
      id: props.dealId,
      name: props.dealData.name || ''
    }
  }
  if(props.dealCustomer){
    formData.client = {
      id: props.dealCustomer.id,
      name: props.dealCustomer.name || ''
    }
  }
});

defineExpose({
  getFormData,
  getMarkDoneFormData,
  getWorkStatusFormData,
  resetForm,
  reloadMinutes
});

</script>

<style scoped> 
.btn-margin {
    margin-right: 20px;
    margin-bottom: 10px;
}
.work-status-pill {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: capitalize;
}
.work-status-meta {
    font-size: 0.72rem;
    opacity: 0.85;
    margin-left: 6px;
}
.inner-tabs {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    margin: 0 0 12px;
    background: #f3f5fa;
    border-radius: 10px;
}
.inner-tab {
    appearance: none;
    border: none;
    background: transparent;
    color: #6b7691;
    font-size: 0.8125rem;
    font-weight: 600;
    padding: 7px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}
.inner-tab:hover:not(.inner-tab--active) {
    color: #1f2a44;
}
.inner-tab--active {
    background: #ffffff;
    color: #6366f1;
    box-shadow: 0 1px 3px rgba(20, 24, 40, 0.08), 0 1px 2px rgba(20, 24, 40, 0.04);
}
.inner-tab:focus-visible {
    outline: 2px solid #6366f1;
    outline-offset: 2px;
}
@media (max-width: 575.98px) {
    .inner-tabs {
        padding: 3px;
        border-radius: 8px;
        margin: 0 0 10px;
    }
    .inner-tab {
        padding: 6px 10px;
        font-size: 0.75rem;
        border-radius: 6px;
        flex: 1 1 auto;
        text-align: center;
    }
}
@media (max-width: 374.98px) {
    .inner-tab {
        padding: 6px 8px;
        font-size: 0.72rem;
    }
}
.more-options-btn {
    appearance: none;
    border: 1px solid #c7d2fe;
    background: #ffffff;
    color: #6366f1;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    line-height: 1.2;
    transition: background 160ms ease, color 160ms ease, border-color 160ms ease;
}
.more-options-btn:hover {
    background: #eef0ff;
    border-color: #6366f1;
}
.more-options-btn:focus-visible {
    outline: 2px solid #6366f1;
    outline-offset: 2px;
}
.more-options-btn i {
    font-size: 0.625rem;
}
</style>
